module.exports = require("https");


//////////////////
// WEBPACK FOOTER
// external "https"
// module id = 35
// module chunks = 0 1 15